<div class="px-3">

  <div class="rem-text-default mb-6">
    <div class="flex align-items-end">

      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-receipt font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">Monthly Billing Config</div>
        <div class="text-right mt-2">Manage monthly biiling config of clients</div>
      </div>
      
    </div>
  </div>


  <div class="flex justify-content-end">


      <remitter-button   
        pTooltip="Create New Billing Client"
        tooltipPosition="left"
        (click)="onOpenClientForm()" 
        label='Create New'
        icon='plus'
        severity='info'
      >     
      </remitter-button>
  </div>

    
  <div 
      class="mt-4"
       *ngIf="!hasTableData && clients !== undefined"
        style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
        🚫 No client records found
  </div>

  <div
    *ngIf="hasTableData"
    class="mt-4"
    >
    <div
      class="px-2">
      <div class="font-bold">
        Clients
      </div>
    </div>
  
    <div class="mt-2 text-xs">
      <div class="px-2">
        <div class="p-0 flex align-items-center justify-content-between surface-100">
          <div class="cell-expand">
              
          </div>
          <div class="cell font-bold">
              Client Id
          </div>
          <div class="cell font-bold">
              Company Name
          </div>
          <div class="cell cell-large font-bold">
              Street Address
          </div>
          <div class="cell font-bold">
              City
          </div>
          <div class="cell font-bold">
              State Abbrevation
          </div>
          <div class="cell font-bold">
              Postal Code
          </div>
          <div class="cell font-bold">
              Country
          </div>
          <div class="cell cell-large font-bold">
              Recipient To Full Name
          </div>
          <div class="cell font-bold">
              Terms Days
          </div>
          <div class="cell font-bold">
              Monthly Minimum
          </div>
          <div class="cell font-bold">
              Callback Range
          </div>
          <div class="cell-action font-bold">
              Action
          </div>
        </div>
      </div>

      <div class="mt-2 px-3">
        <p-dataView
          #dv
          [value]="clients"      
        >
            <ng-template pTemplate="list" let-clients>     
              <div class="grid">
                <div class="col-12 p-0 border-bottom-1 border-gray-300" *ngFor="let client of clients; let i = index">
                  <div class="flex align-items-center justify-content-between">
                      <div class="cell-expand">
                        <i  
                            (click)="toggleDetails(client.ClientId)"
                            [pTooltip]="(!isShowDetails.includes(client.ClientId)? 'Show' : 'Hide') +' Client Billing Term Details'"
                            tooltipPosition='top' 
                            [ngClass]="{
                              'pi-chevron-down': isShowDetails.includes(client.ClientId),                          
                              'pi-chevron-right': !isShowDetails.includes(client.ClientId)
                            }"
                            class="pi text-xs cursor-pointer"  ></i>
                      </div>
                      <div class="cell">
                        {{client.ClientId}}
                      </div>
                      <div class="cell">
                        {{client.CompanyName}}
                      </div>
                      <div class="cell cell-large">
                        {{client.StreetAddress}}
                      </div>
                      <div class="cell">
                        {{client.City}}
                      </div>
                      <div class="cell">
                        {{client.StateAbbr}}
                      </div>
                      <div class="cell">
                        {{client.PostalCode}}
                      </div>
                      <div class="cell">
                        {{client.Country}}
                      </div>
                      <div class="cell cell-large">
                        {{client.RecientToFullName}}
                      </div>
                      <div class="cell">
                        {{client.TermsDays}}
                      </div>
                      <div class="cell">
                        {{client.MonthlyMinimum}}
                      </div>
                      <div class="cell">
                        {{client.CallbackRange}}
                      </div>
                      <div class="cell-action flex">
                          <icon-button
                            pTooltip="Edit"
                            tooltipPosition='left'
                            (click)="onOpenClientForm(client)"
                            [icon]="'pencil'"
                            [styleClass]="'mr-1'"
                          />

                          <icon-button
                            pTooltip='Archive'
                            tooltipPosition='left'
                            (click)="onOpenDeleteModal(client.ClientId, TYPE_TO_DELETE.CLIENT)"
                            [icon]="'trash'"
                          />                      
                      </div>
                  </div>

                <div 
                 [ngClass]="{'hidden': !isShowDetails.includes(client.ClientId)}"
                 class="px-5 mt-2 pb-5">
                  <div class="flex justify-content-between align-items-center mb-2">
                    <div class="font-bold text-sm">
                      Billing Term Details
                    </div>

                    <icon-button
                        (click)="onOpenBillingDetailForm(client.ClientId)"
                        pTooltip='Add New Client Billing Term Detail'
                        tooltipPosition='left'
                        icon="plus"
                        label="Add"
                      />  
                  </div>
                    <p-table 
                      [rows]="5"
                      [rowsPerPageOptions]="[5, 10, 30, 50]"
                      [paginator]="true"
                      *ngIf="isArrayWithData(client.BillingTermDetails)"
                      styleClass="border-1 border-gray-300"
                      [value]="client.BillingTermDetails"                
                      [tableStyle]="{ 'min-width': '50rem' }"
                    >

                        <ng-template pTemplate="header">
                            <tr class="text-xs detail-header">
                                <th>Client Billing Term Detail Id</th>
                                <th>Creditor</th>
                                <th>Creditor Id</th>
                                <th>Term Type</th>
                                <th>Fee Percentage</th>
                                <th>Min</th>  
                                <th>Max</th>  
  
                                <th>Action</th>            
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-detail>
                            <tr class="text-xs">
                                <td> {{detail.ClientBillingTermDetailId}}</td>
                                <td> {{detail.Creditor}}</td>
                                <td> {{detail.CreditorId}}</td>
                                <td> {{detail.TermType}}</td>
                                <td> {{detail.FeePercentage}}</td>
                                <td> {{detail.Min}}</td>
                                <td> {{detail.Max}}</td>
                
                                <td>
                                  <div class="flex align-items-center gap-2">
                                    <i
                                      pTooltip="Edit"
                                      tooltipPosition='left'
                                      (click)="onOpenBillingDetailForm(client.ClientId, detail)"
                                      class="pi pi-pencil text-xs cursor-pointer"
                                    ></i> 
                                    <i
                                      pTooltip="Archive"
                                      tooltipPosition='left'
                                      (click)="onOpenDeleteModal(detail.ClientBillingTermDetailId, TYPE_TO_DELETE.DETAIL, detail.ClientId)"
                                      class="pi pi-trash text-xs cursor-pointer"
                                    ></i>                      
                                  </div>
                              </td>   
                            </tr>
                        </ng-template>
                    </p-table>

                    <div 
                      *ngIf="!isArrayWithData(client.BillingTermDetails) && !appService.isShowPageSpinner"
                        style="text-align:center; color: #336699; font-size: 1rem;">
                      🚫 No biiling term details for this client
                    </div>
                </div>

                </div>
              </div>          
            </ng-template>
        </p-dataView>
        <p-paginator 
            (onPageChange)="onPageChangeClient($event)" 
            [rows]="rowsClient" 
            [totalRecords]="totalRecordsClient" 
            [rowsPerPageOptions]="[10, 30, 50]" />
      </div>
    </div>
  </div>
 

</div>

<ng-template #noData>–</ng-template>

<p-sidebar 
  (onHide)="clearClientForm()"
  [(visible)]="isShowClientForm" styleClass="w-6" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium">{{toEditClientId? 'Edit ' : 'Create New '}} Client</div>
      <div class="grid">
        <div class="col-12 md:col-6">

          <div class="mt-6">
            <p-floatLabel>
              <input
                  [(ngModel)]="companyName"
                  pInputText
                  type="text" 
                  class="w-full"
                  styleClass="w-full"
                  id="CompanyName" placeholder="Company Name"
              /> 
              <label for="CompanyName">Company Name</label>
            </p-floatLabel>
          </div>
          <div class="mt-6">
            <p-floatLabel>
              <input
                  [(ngModel)]="streetAddress"
                  pInputText
                  type="text" 
                  class="w-full"
                  styleClass="w-full"
                  id="StreetAddress" placeholder="Street Address"
              /> 
              <label for="StreetAddress">Street Address</label>
            </p-floatLabel>
          </div>

          <div class="mt-6">
            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="monthlyMinimum"
                    class="w-full"
                    styleClass="w-full"
                    inputId="integeronly" 
                    placeholder="Monthly Minimum"
              /> 
              <label for="MonthlyMinimum">Monthly Minimum</label>
            </p-floatLabel>
          </div>

          <div class="mt-6">
            <p-floatLabel>
              <p-dropdown 
                   [filter]="true"
                   [(ngModel)]="stateAbbr"
                   styleClass="w-full"
                   id="stateOptions" 
                   placeholder="Select State Abbrevation"
                   [options]="stateOptions"
                   optionLabel="Label"
                   optionValue="Value"
                >
                <ng-template let-state pTemplate="item">
                    <div class="flex align-items-center justify-content-between">                      
                        <div>{{ state.Label }}</div>
                        <div>{{ state.Value }}</div>
                    </div>
                </ng-template>
                </p-dropdown>

             
              <label for="stateOptions">State Abbrevation</label>
            </p-floatLabel>
          </div>

          <div class="mt-6">
            <p-floatLabel>
              <input
                  [(ngModel)]="recipientToFullName"
                  pInputText
                  type="text" 
                  class="w-full"
                  styleClass="w-full"
                  id="recipientToFullName" 
                  placeholder="Recipient To Full Name"
              /> 
              <label for="recipientToFullName">Recipient To Full Name</label>
            </p-floatLabel>
            <div class="rem-error" *ngIf="isSaveClickedClient && !recipientToFullName">
                Recipient to Full Name is required
            </div>
          </div>  


        </div>
        <div class="col-12 md:col-6">
          <div class="mt-6">
            <p-floatLabel>
              <input
                  [(ngModel)]="country"
                  pInputText
                  type="text" 
                  class="w-full"
                  styleClass="w-full"
                  id="country" placeholder="Country"
              /> 
              <label for="country">Country</label>
            </p-floatLabel>
          </div>      


          <div class="mt-6">
            <p-floatLabel>
                <p-inputNumber 
                  [useGrouping]="false"
                  [(ngModel)]="postalCode"
                  inputId="postalCode" 
                  placeholder="Postal Code"
                  class="w-full"
                  styleClass="w-full"
                  id="postalCode" 
                  placeholder="Postal Code"
              /> 
              <label for="postalCode">Postal Code</label>
            </p-floatLabel>
          </div>


          <div class="mt-6">
            <p-floatLabel>
              <input
                  [(ngModel)]="city"
                  pInputText
                  type="text" 
                  class="w-full"
                  styleClass="w-full"
                  id="city" placeholder="City"
              /> 
              <label for="city">City</label>
            </p-floatLabel>
          </div>

          <div class="mt-6">
            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="termsDays"
                    class="w-full"
                    styleClass="w-full"
                    inputId="integeronly" 
                    placeholder="Terms Days"
                    id="termsDays"
              /> 
              <label for="termsDays">Terms Days</label>
            </p-floatLabel>
            <div class="rem-error" *ngIf="isSaveClickedClient && !termsDays">
                Terms Days is required
            </div>
          </div>

          <div class="mt-6">
            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="callbackRange"
                    class="w-full"
                    styleClass="w-full"
                    inputId="integeronly" 
                    placeholder="Callback Range"
                    id="callbackRange"
              /> 
              <label for="callbackRange">Callback Range</label>
            </p-floatLabel>
            <div class="rem-error" *ngIf="isSaveClickedClient && !callbackRange">
                Callback Range is required
            </div>
          </div>            
        </div>
      </div>

      <div class="flex justify-content-end mt-4">
        <remitter-button
            (click)="onSaveBillingClient()" 
            label='Save'
            icon='send'
        >     
        </remitter-button>
      </div>
    </div>
</p-sidebar>

<p-sidebar 
  (onHide)="clearBillingDetailForm()"
  [(visible)]="isShowBillingTermForm" styleClass="w-4" position="right">
    <div class="bg-white shadow-3 border-round p-4">
      <div class="text-xl font-medium">{{toEditBillingDetail? 'Edit ' : 'Add New '}} Billing Term Detail</div>

      <div>       
        <div class="mt-6">
          <creditor-autocomplete
            styleClass="w-full"
            [(selectedCreditor)]="selectedCreditor"
          ></creditor-autocomplete>
        </div>
        
        <div class="mt-6">
            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="min"
                    class="w-full"
                    styleClass="w-full"                    
                    placeholder="Min"
                    id="min"
                    inputId="integeronly"
              /> 
              <label for="min">Min</label>
            </p-floatLabel>
          </div>  

        <div class="mt-6">
            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="max"
                    class="w-full"
                    styleClass="w-full"
                    placeholder="Max"
                    id="max"
                    inputId="integeronly"
              /> 
              <label for="max">Max</label>
            </p-floatLabel>
        </div>  

        <div class="mt-6">
          <p-floatLabel>
                <p-dropdown 
                   styleClass="w-full"
                   id="termTypeOptions" 
                   placeholder="Select Term Type"
                   [options]="termTypeOptions"
                   optionLabel="Label"
                   optionValue="Value"
                   [(ngModel)]="termTypeId"
                >
                <ng-template let-term pTemplate="item">
                    <div class="flex align-items-center justify-content-between">                      
                        <div>{{ term.Label }}</div>
                        <div>{{ term.Value }}</div>
                    </div>
                </ng-template>
              </p-dropdown> 
            
              <label for="termTypeOptions">Term Type</label>
            </p-floatLabel>
       
             <div class="rem-error" *ngIf="isSaveClickedBillingTermDetail && !termTypeId">
                Term Type is required
            </div>
        </div>

        <div class="mt-6">
            <p-floatLabel>
              <p-inputNumber 
                    [(ngModel)]="feePercentage"
                    class="w-full"
                    styleClass="w-full"
                    placeholder="Fee Percentage"
                    id="feePercentage"
                    [maxFractionDigits]="9"
              /> 
              <label for="feePercentage">Fee Percentage</label>
            </p-floatLabel>

             <div class="rem-error" *ngIf="isSaveClickedBillingTermDetail && !feePercentage">
                Fee Percentage is required
            </div>
        </div>  
      </div>



      <div class="flex justify-content-end mt-4">
        <remitter-button
            (click)="onSaveBillingTermDetail()" 
            label='Save'
            icon='send'
        >     
        </remitter-button>
      </div>
    </div>
</p-sidebar>
  
  
<common-delete-modal 
[(visible)]="isDeleteModalVisible" 
[message]="deleteMessage"
width="30vw"
(actionClicked)="onConfirmDelete()">
</common-delete-modal>

